// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Anzt","amount":"Amount_amount__-bpBq","tip":"Amount_tip__aOfCu","tipHeader":"Amount_tipHeader__1PVOP","tipsWrap":"Amount_tipsWrap__ea7O0"};